import React from 'react';
import { AppComponent } from 'utils/components';

export default function TextInput(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>text input</div>;
}
